import { useEffect, useState } from "react";
import { PokemonCard } from "./PokemonCard";

export const Pokemon = () => {
  const [pokemon, setPokemon] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search,setSearch]=useState("");
  const Api = "https://pokeapi.co/api/v2/pokemon?limit=500";

  console.log(pokemon);

  const handlePokemon = async () => {
    try {
      const res = await fetch(Api);
      const data = await res.json();

      const detailedPokemonData = data.results.map(async (curr) => {
        const detailres = await fetch(curr.url);
        const detaildata = await detailres.json();
        return detaildata;
      });

      const detaildatapokemons = await Promise.all(detailedPokemonData);
      setPokemon(detaildatapokemons);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setError(err);
    }
  };

  useEffect(() => {
    handlePokemon();
  }, []);

  if (loading) {
    return <h1>Loading...</h1>;
  }

  if (error) {
    return <h1>{error.message}</h1>;
  }

  const searchdata=pokemon.filter((currpokemon)=>currpokemon.name.toLowerCase().includes(search.toLowerCase()))

  return (
    <>
      <section className="container">
        <header>
          <h1> Lets Catch Pokémon</h1>
        </header>
        <div className="pokemon-search">
          <p >Search:<input type="text"  value={search} onChange={(e)=>setSearch(e.target.value)}/></p>
        </div>
        <div>
          <ul className="cards">
            {/* {pokemon.map((currr) => { */}
            {searchdata.map((currr) => {
              return (
                <li className="pokemon-card" key={currr.id} >
                  <PokemonCard currr={currr}/>
                </li>
              );
            })}
          </ul>
        </div>
      </section>
    </>
  );
};
